import hvpAuthenticatedApi from "../api/hvpAuthenticatedApi";
import {
  ICollaborator,
  ICollaboratorBase,
  ApiResponseList,
  ICollaboratorWithJobAndEmployment,
} from "../shared/types/";
import { BaseServiceLegacy } from "./base.service.legacy";

export class CollaboratorService extends BaseServiceLegacy<
  ICollaborator,
  ICollaboratorBase
> {
  constructor() {
    super("/collaborators");
  }

  async getCollaboratorsForWeb(): Promise<ICollaborator[]> {
    console.log("inside the getWeb");
    const response = await hvpAuthenticatedApi.get(
      "/collaborators/getAllForWeb"
    );
    console.log("the response", response.data);
    return response.data;
  }

  async getCollaboratorsWithJobAndEmployment(
    date?: string
  ): Promise<ApiResponseList<ICollaboratorWithJobAndEmployment>> {
    const params = date ? { date } : undefined;

    const response = await hvpAuthenticatedApi.get<
      ApiResponseList<ICollaboratorWithJobAndEmployment>
    >(`/collaborators/withJobAndEmployment`, { params });

    // Sort by job sortingOrder
    const sortedData = response.data.data.sort((a, b) => {
      const sortA = a?.job?.sortingOrder ?? Infinity;
      const sortB = b?.job?.sortingOrder ?? Infinity;
      return sortA - sortB;
    });

    return {
      ...response.data,
      data: sortedData,
    };
  }
}
